// import React, { useEffect } from 'react'

// import { useDispatch } from 'react-redux'

import styled from 'styled-components'

import Sidebar from '../components/dashboard/Sidebar'
import Header from '../components/Header'

import { P } from '../style/Typography.style'

import { useUpdateSystemVersion } from '../hooks/useUpdateSystemVersion'
import { useTabLocalInactivity } from '../hooks/useTabLocalInactivity'

const DashboardLayout = ({ children }) => {
  const { showAlert } = useUpdateSystemVersion()

  useTabLocalInactivity(() => {
    alert('You have been logged out due to inactivity.')

    sessionStorage.removeItem('recruiterToken')
    localStorage.removeItem('user')
    localStorage.removeItem('id')
    localStorage.removeItem('qualifications')
    localStorage.removeItem('skills')
    localStorage.removeItem('salaries')
    localStorage.removeItem('jobDetails')
    localStorage.removeItem('reachedStep')
    localStorage.removeItem('step')
    localStorage.removeItem('jobTitle')

    window.location.href = '/login'
  })

  return (
    <StyledDashboard>
      <Header />
      <div className="contentWrapper">
        <Sidebar />

        <div className="content">
          {showAlert && (
            <StyledAlert>
              <P weight="500" size=".875rem">
                🔄 Action Required: System Update Completed
              </P>
              <P size=".875rem" marginTop="0.5rem">
                Hi there! 👋 We’ve just rolled out a system update to improve
                your experience and keep everything running smoothly. To make
                sure you’re using the most up-to-date version and avoid any
                unexpected issues, please reload this page. It’ll only take a
                moment, and you’ll be back to work with the latest improvements!
              </P>
            </StyledAlert>
          )}
          {children}
        </div>
      </div>
    </StyledDashboard>
  )
}

export default DashboardLayout

const StyledAlert = styled.div`
  height: 100px;
  width: 100%;
  padding: 0.5rem;
  margin-top: 1rem;
  border: 1px solid rgb(174, 179, 201);
  border-radius: 5px;
`

const StyledDashboard = styled.div`
  width: 100%;
  max-width: 105vw;
  height: 100vh;
  background: #f9f9fc;
  overflow-y: hidden;

  .contentWrapper {
    width: 100%;
    height: 100%;
    display: flex;
    overflow-y: auto;

    .content {
      width: 100%;
      margin-right: 2rem;

      @media (max-width: 768px) {
        margin-left: 4rem;
      }
    }
  }
`
